var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJoinedSyndicates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92021 17.5008C9.70126 18.2819 9.70126 19.5482 8.92021 20.3293C8.13916 21.1103 6.87283 21.1103 6.09178 20.3293C5.31073 19.5482 5.31073 18.2819 6.09178 17.5008C6.87283 16.7198 8.13916 16.7198 8.92021 17.5008",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9082 17.5008C18.6892 18.2819 18.6892 19.5482 17.9082 20.3293C17.1271 21.1103 15.8608 21.1103 15.0798 20.3293C14.2987 19.5482 14.2987 18.2819 15.0798 17.5008C15.8608 16.7198 17.1271 16.7198 17.9082 17.5008",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14321 8.95371C6.92426 9.73476 6.92426 11.0011 6.14321 11.7821C5.36216 12.5632 4.09583 12.5632 3.31478 11.7821C2.53373 11.0011 2.53373 9.73476 3.31478 8.95371C4.09583 8.17266 5.36216 8.17266 6.14321 8.95371",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 3.67075C14.1952 4.4518 14.1952 5.71813 13.4142 6.49918C12.6331 7.28023 11.3668 7.28023 10.5858 6.49918C9.80472 5.71813 9.80472 4.4518 10.5858 3.67075C11.3668 2.8897 12.6331 2.8897 13.4142 3.67075",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6852 8.95371C21.4662 9.73476 21.4662 11.0011 20.6852 11.7821C19.9041 12.5632 18.6378 12.5632 17.8568 11.7821C17.0757 11.0011 17.0757 9.73476 17.8568 8.95371C18.6378 8.17266 19.9041 8.17266 20.6852 8.95371",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 11.0299C14.1952 11.8109 14.1952 13.0773 13.4142 13.8583C12.6331 14.6394 11.3668 14.6394 10.5858 13.8583C9.80472 13.0773 9.80472 11.8109 10.5858 11.0299C11.3668 10.2488 12.6331 10.2488 13.4142 11.0299",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 14.0801L15.35 17.2801",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.86 14.0801L8.65 17.2701",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.09 11.9L6.64 10.91",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.4398V7.08984",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.91 11.9L17.36 10.91",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinedSyndicates);
export default __webpack_public_path__ + "static/media/joined-syndicates.05c5b2ab1585be3c89be2cbf032fde38.svg";
export { ForwardRef as ReactComponent };